import { useEffect, useRef, useState } from "react";

import { scrapListSearchPeriods, userState } from "../../../interface/MainInterface";
import { HttpUnAuthApi } from "../../../interface/unauth-api";

// CSS
import "./Navigation.css";
import { Box, CardMedia, IconButton } from "@mui/material";
import LoadingCircle from "../../../utils/LoadingCircle";
import Toast from "../../../utils/Toast";

interface propsType {
  userState: userState;
  selectedPeriod: string;
  callback: any;
}

const unAuthAPI = new HttpUnAuthApi();

const Navigation = (props: propsType) => {
  const toastRef: any = useRef();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    return () => {
      setIsLoading(false);
    };
  }, []);

  const create_scrap_info = async () => {
    // 먼저 confirm을 처리하고, 이후에 비동기 코드 실행 (iOS 18.6.2 버전에서 동작하지 않아서 confirmed 처리)
    const confirmed = window.confirm("새로운 보드를 생성하시겠습니까?");
    if (!confirmed) return;

    const param: any = {
      command: "create_scrap_info",
      user_id: props.userState.id,
    };

    setIsLoading(true);
    const res = await unAuthAPI.post(param);
    if (res.code === "200") {
      props.callback({ command: "finish_create_new_scrap" });
    } else {
      toastRef.current?.toast("스크랩 생성에 실패했습니다.", "error", 4000, {
        vertical: "top",
        horizontal: "center",
      });
    }
    setIsLoading(false);
  };
  return (
    <>
      <article className="article-02 no-margin">
        <div className="brief-list-wrap">
          <div className="option-wrap">
            <div className="period-wrap">
              <div className="tabs">
                {scrapListSearchPeriods.map((data: any, index: number) => (
                  <div key={`radio-detail-${index + 1}`} className="tab">
                    <input
                      type="radio"
                      id={`radio-detail-${index + 1}`}
                      name="tabs"
                      onChange={() => {
                        props.callback({ command: "selected_period", value: data.key });
                      }}
                    />
                    <label className={props.selectedPeriod === data.key ? "tab color-white" : "tab"} htmlFor={`radio-detail-${index + 1}`}>
                      {data.title}
                    </label>
                  </div>
                ))}

                <span
                  className={
                    props.selectedPeriod === "recent"
                      ? "glider period1"
                      : props.selectedPeriod === "week"
                      ? "glider period2"
                      : props.selectedPeriod === "month"
                      ? "glider period3"
                      : "glider period4"
                  }
                ></span>
              </div>
            </div>
            <div className="new-scrap-wrap">
              <IconButton sx={{ p: 0 }} onClick={create_scrap_info}>
                <CardMedia component={"img"} image="/images/btn-addboard.png" />
              </IconButton>
            </div>
          </div>
        </div>
      </article>
      <Toast ref={toastRef} />
      <LoadingCircle loading={isLoading} />
    </>
  );
};

export default Navigation;
